<template>
    <div>
        <div style="height: 25px;">申请数量的统计范围是目前已公开的专利，一般发明专利在申请后3-18个月公开，实用新型专利和外观设计专利在申请后6个月左右公开</div>
        <el-container>
            <el-container>
                <el-aside width="240px">
                    <el-menu default-active="1" @open="handleOpen" @close="handleClose" :default-openeds="['1', '2', '3']" @select="handleSelect">
                        <el-submenu index="1">
                            <template slot="title">
                                <span>1.趋势分析</span>
                            </template>
                            <el-menu-item index="1-1">专利申请趋势</el-menu-item>
                            <el-menu-item index="1-2">专利公开趋势</el-menu-item>
                            <el-menu-item index="1-3">专利转让趋势</el-menu-item>
                            <el-menu-item index="1-4">专利许可趋势</el-menu-item>
                            <el-menu-item index="1-5">专利质押趋势</el-menu-item>
                        </el-submenu>
                        <el-submenu index="2">
                            <template slot="title">
                                <span>2.排名分析</span>
                            </template>
                            <el-menu-item index="2-1">申请人专利量排名</el-menu-item>
                            <el-menu-item index="2-2">发明人专利量排名</el-menu-item>
                            <el-menu-item index="2-3">申请人国别专利量排名</el-menu-item>
                            <el-menu-item index="2-4">专利公开国别专利量排名</el-menu-item>
                            <el-menu-item index="2-5">中国省市专利量排名</el-menu-item>
                        </el-submenu>
                        <el-submenu index="3">
                            <template slot="title">
                                <span>3.技术分析</span>
                            </template>
                            <el-menu-item index="3-1">IPC大类分布</el-menu-item>
                            <el-menu-item index="3-2">IPC小类分布</el-menu-item>
                            <el-menu-item index="3-3">IPC大组分布</el-menu-item>
                            <el-menu-item index="3-4">IPC小组分布</el-menu-item>
                            <el-menu-item index="3-5">洛迦诺分布</el-menu-item>
                        </el-submenu>
                    </el-menu>
                </el-aside>
                <el-main width="850px">
                    <v-applicant-info-bar :data="data" v-if="menuActive === '2-1'"></v-applicant-info-bar>
                    <v-inventor-bar :data="data" v-if="menuActive === '2-2'"></v-inventor-bar>
                    <v-apply-country :data="data" v-if="menuActive === '2-3'"></v-apply-country>
                    <v-open-pt-country :data="data" v-if="menuActive === '2-4'"></v-open-pt-country>
                    <v-province :data="data" v-if="menuActive === '2-5'"></v-province>

                    <v-apply-year-line :data="data" v-if="menuActive === '1-1'"></v-apply-year-line>
                    <v-open-yeary-line :data="data" v-if="menuActive === '1-2'"></v-open-yeary-line>
                    <v-trainsfer-line :data="data" v-if="menuActive === '1-3'"></v-trainsfer-line>
                    <v-exploitation-line :data="data" v-if="menuActive === '1-4'"></v-exploitation-line>
                    <v-preservation-line :data="data" v-if="menuActive === '1-5'"></v-preservation-line>

                    <v-ipc-class :data="data" v-if="menuActive === '3-1'"></v-ipc-class>
                    <v-ipc-sub-class :data="data" v-if="menuActive === '3-2'"></v-ipc-sub-class>
                    <v-ipc-group :data="data" v-if="menuActive === '3-3'"></v-ipc-group>
                    <v-ipc-sub-group :data="data" v-if="menuActive === '3-4'"></v-ipc-sub-group>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
import vApplicantInfoBar from './ApplicantInfoBar.vue';
import vApplyCountry from './ApplyCountry.vue';
import vApplyYearLine from './ApplyYearLine.vue';
import vExploitationLine from './ExploitationLine.vue';
import vInventorBar from './InventorBar.vue';
import vOpenYearyLine from './OpenYearyLine.vue';
import vPreservationLine from './PreservationLine.vue';
import vProvince from './Province.vue';
import vTrainsferLine from './TrainsferLine.vue';
import vOpenPtCountry from './OpenPtCountry.vue';
import vIpcClass from './IpcClass.vue';
import vIpcSubClass from './IpcSubClass.vue';
import vIpcGroup from './IpcGroup.vue';
import vIpcSubGroup from './IpcSubGroup.vue';
export default {
    components: {
        vApplicantInfoBar,
        vApplyCountry,
        vApplyYearLine,
        vExploitationLine,
        vInventorBar,
        vOpenYearyLine,
        vPreservationLine,
        vProvince,
        vTrainsferLine,
        vOpenPtCountry,
        vIpcClass,
        vIpcSubClass,
        vIpcGroup,
        vIpcSubGroup
    },
    props: ['data'],
    data() {
        return {
            menuActive: '1-1'
        }
    },
    created() {

    },
    methods: {
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleSelect(key, keyPath) {
            console.log(key, keyPath);
            this.menuActive = key;
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        }
    }
}
</script>

<style scoped>
::v-deep .el-submenu__title {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    color: white;
    font-weight: bold;
    background-color: #409EFF;
}
::v-deep .el-submenu .el-menu-item {
    height: 35px;
    line-height: 35px;
}
</style>